import createAxios from 'config/axios'

export const getAccountsFinancialPosition = () => createAxios.get('samwise/position/accounts')

export default getAccountsFinancialPosition
